import styled from 'styled-components';

export const StyledContentAreaLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  width: 100%;
  flex: 1;
`;
